import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from "ag-grid-angular";
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { MyDatePickerModule } from 'mydatepicker';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { ComplaintsService } from '../../services/complaints.service';
import { DirectivesModule } from './../../directives/directives.module';
import { EditReservationModule } from './../trip-reservations/edit-reservation/edit-reservation.module';
import { ComplaintsRoutingModule } from './complaints-routing.module';
import { ComplaintsResolutionComponent } from './complaints-resolution/complaints-resolution.component';
import { ComplaintsDashboardComponent } from './complaints-dashboard/complaints-dashboard.component';
import { DashboardFiltersComponent } from './complaints-dashboard/components/dashboard-filters/dashboard-filters.component';
import { DashboardKpisComponent } from './complaints-dashboard/components/dashboard-kpis/dashboard-kpis.component';
import { DashboardTrendChartComponent } from './complaints-dashboard/components/dashboard-trend-chart/dashboard-trend-chart.component';
import { DashboardTypeBarsComponent } from './complaints-dashboard/components/dashboard-type-bars/dashboard-type-bars.component';
import { DashboardRankTableComponent } from './complaints-dashboard/components/dashboard-rank-table/dashboard-rank-table.component';
import {
  DashboardRepeatMembersComponent
} from './complaints-dashboard/components/dashboard-repeat-members/dashboard-repeat-members.component';
import { GridComplaintComponent } from './complaints-resolution/components/grid-complaint/grid-complaint.component';
import { ManagerComplaintComponent } from './complaints-resolution/components/manager-complaint/manager-complaint.component';
import {CompanyService} from '../../core/services/company.service';
import { EmailsInputModule } from '../../utils/emails-input/emails-input.module';
import {GridComplaintsResponsesModule} from "app/utils/grid-complaints-responses/grid-complaints-responses.module";

@NgModule({
  imports: [
    CommonModule,
    ComplaintsRoutingModule,
    AgGridModule,
    Trip2ThemeModule,
    DirectivesModule,
    MyDateRangePickerModule,
    MyDatePickerModule,
    FormsModule,
    AgGridModule,
    ReactiveFormsModule,
    EditReservationModule,
    EmailsInputModule,
    GridComplaintsResponsesModule
  ],
  declarations: [
    ComplaintsResolutionComponent,
    ManagerComplaintComponent,
    GridComplaintComponent,
    ComplaintsDashboardComponent,
    DashboardFiltersComponent,
    DashboardKpisComponent,
    DashboardTrendChartComponent,
    DashboardTypeBarsComponent,
    DashboardRankTableComponent,
    DashboardRepeatMembersComponent
  ],
  providers: [
    ComplaintsService,
    CompanyService
  ]
})
export class ComplaintsModule { }



// WEBPACK FOOTER //
// ./src/app/pages/complaints/complaints.module.ts